module.exports = __webpack_public_path__ + "h5/img/jifen-icon.9555bea7.png";